import React, { Component, Suspense, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import '../../node_modules/font-awesome/scss/font-awesome.scss';
import Axios from 'axios';
import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import routes from "../route";
import config from '../config';
//import Unidade from '../../../e-saude_server/src/app/models/Unidade';
//import { requireLogin, isAuthenticated  } from "../services/auth";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';



const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'),
    loading: Loader
});



class App extends Component {

    

    render() {   
        
        const menu = routes.map((route, index) => {
          return (route.component) ? (
              <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={props => (
                      <route.component {...props} />
                  )} />
          ) : (null);
        });

        
        
        return (  
                   
            <Aux>
                <NotificationContainer/>
                <div id='load_data'></div>
                <ScrollToTop>
                    <Suspense fallback={<Loader/>}>
                        <Switch>
                            
                            {menu}
                            
                            <Route path="/" component={AdminLayout} />
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </Aux>
        );
    }
}

export default App;
